import { PagingDataTable } from "./PagingDataTable";
export default PagingDataTable;